/**
 * Estados de una tabla o panel: cargando y vacio. Se comparten para que las
 * cuatro pantallas digan lo mismo de la misma forma.
 */
import type { ReactElement, ReactNode } from 'react';

export function LoadingBlock({ label = 'Cargando…' }: { readonly label?: string }): ReactElement {
  return (
    <p className="loading" role="status">
      {label}
    </p>
  );
}

export interface EmptyStateProps {
  readonly title: string;
  readonly hint?: ReactNode;
}

export function EmptyState({ title, hint }: EmptyStateProps): ReactElement {
  return (
    <div className="empty">
      <p>{title}</p>
      {hint === undefined ? null : <p className="muted">{hint}</p>}
    </div>
  );
}
